export default __webpack_public_path__ + "static/media/bigAvatar.4c08a0c7.png";